import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterSideFromPlay extends Bloc {

	constructor (src, ctx) {

		super("filtersidefromplay", src, ctx);
		this.f = (src, ins) => [card => (ins[0] ? card.leftFromPlay : card.rightFromPlay)];
		this.types = [Types.bool];
	}
}